import { GetMediumListForFeatureCopyResponse } from './api-services/getMediumListForFeatureCopy.service';

/**
 * 特集コピー画面の値を管理するクラス
 *
 * @export KYMW4502Model
 * @class KYMW4502Model
 */
export class KYMW4502Model {
  public delivCatalogId = '';
  public orderCode = '';
  public copiedCatalogId = '';
  public copiedOrderCode = '';
  public mediumTypeList: Array<any> = new Array<any>();

  public setMediumListForFeatureCopyList(mediumListForFeatureCopy: GetMediumListForFeatureCopyResponse) {
    this.mediumTypeList = mediumListForFeatureCopy.MediumList.map(_ => {
      return {
        checked: false,
        copiable: _.CanCopy === 'true',
        mediumType: _.MediumType,
        mediumName: _.MediumName
      }
    });
  }
}
